import { render, staticRenderFns } from "./purposesCloudHistory.vue?vue&type=template&id=cd63eada&scoped=true&"
import script from "./purposesCloudHistory.vue?vue&type=script&lang=js&"
export * from "./purposesCloudHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd63eada",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCardTitle,VCol})
